export function splitTime(unixTimestamp) {
  // Convert UNIX timestamp to Date format
  const date = new Date(unixTimestamp * 1000);

  let hour = 0;
  if (unixTimestamp - EMPTY_TIME === 86400) {
    hour = 24;
  } else {
    hour = date.getHours();
  }
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return [hour, minute, second];
}

export function composeTime(hour, minute, second) {
  if (hour > 24) {
    hour = 24;
    minute = 0;
    second = 0;
  }
  if (hour <= 0) hour = 0;

  if (minute > 59) minute = 59;
  if (second > 59) second = 59;

  if (hour === 0 && minute === 0 && second <= 0) second = 0;

  // Format in UNIX timestamp style
  return parseInt(
    (new Date(2000, 0, 1, hour, minute, second).getTime() / 1000).toFixed(0),
    10
  );
}

export function timerFinished(date) {
  const [hour, minute, second] = splitTime(date);
  if (hour <= 0 && minute <= 0 && second <= 0) return true;
  else return false;
}

export const EMPTY_TIME = parseInt(
  (new Date(2000, 0, 1, 0, 0, 0).getTime() / 1000).toFixed(0),
  10
);
